import { render, staticRenderFns } from "./AccountMobile.vue?vue&type=template&id=3fb0a75e&lang=pug&"
import script from "./AccountMobile.vue?vue&type=script&lang=js&"
export * from "./AccountMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports